import React, { useEffect, useState } from "react";

import MyProfile1 from "../../components/home-services/my-profile/MyProfile1";
import MyProfile2 from "../../components/home-services/my-profile/MyProfile2";
import MyProfile3 from "../../components/home-services/my-profile/MyProfile3";
import MyProfile4 from "../../components/home-services/my-profile/MyProfile4";

import ReactMyProfile1 from "!!raw-loader!../../components/home-services/my-profile/MyProfile1";
import ReactMyProfile2 from "!!raw-loader!../../components/home-services/my-profile/MyProfile2";
import ReactMyProfile3 from "!!raw-loader!../../components/home-services/my-profile/MyProfile3";
import ReactMyProfile4 from "!!raw-loader!../../components/home-services/my-profile/MyProfile4";

import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { darcula } from "react-syntax-highlighter/dist/esm/styles/prism";
import PreviewCodeSection from "../../subcomponent/PreviewCode/PreviceCodeSection";

import pretty from "pretty";
const ComponentData = [
  {
    id: 1,
    component: MyProfile1,
    rawString_React: ReactMyProfile1,
  },
  {
    id: 2,
    component: MyProfile2,
    rawString_React: ReactMyProfile2,
  },
  {
    id: 3,
    component: MyProfile3,
    rawString_React: ReactMyProfile3,
  },
  {
    id: 4,
    component: MyProfile4,
    rawString_React: ReactMyProfile4,
  },
];

const MyProfiles = () => {
  return (
    <>
      {ComponentData.map((obj) => {
        return (
          <PreviewCodeSection
            key={obj?.id}
            Component={obj?.component}
            rawString_React={obj?.rawString_React}
          />
        );
      })}
    </>
  );
};

export default MyProfiles;
